import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import Header from '../Header/Header'
import { Link } from 'react-router-dom'
import { Button, Confirm, Icon, Input, Modal, Table } from 'semantic-ui-react'
import { authHeader, history } from '../../_helpers'
import ReactLoading from "react-loading"
import { getDisciplineList, deleteDisciplineData , viewDisciplineData } from '../../actions/DisciplineActions'
import Pagination from 'react-js-pagination'
import { itemsCountPerPage, pageRangeDisplayed, pageSize } from '../../constants/HelperConstants'

const DisciplineContainer = (props) => {
    const { disciplineList, loading, error, getDisciplineList, deleteDisciplineData, viewDisciplineData, singleDisciplineList, count } = props
    let pathname = props.location.pathname
    const [isOpen, setIsOpen]= useState(false)
    const [deleteValue, setDeleteValue] = useState(true)
    const [open, setOpen] = useState(true)
    const [currentUserId, setCurrentUserId] = useState(null)
    const [activePage, setActivePage] = useState(1)
    const [searchTerm, setSearchTerm] = useState("")

    useEffect(() => {
        if(authHeader){
            if(localStorage.getItem('token')){
                authHeader(pathname)
                getDisciplineList(activePage, searchTerm)
            }
            else{
                history.push('/login') 
            }
        }
    }, [getDisciplineList, pathname, activePage, searchTerm])

    const handlePageChange = (pageNumber) => {
        setActivePage(pageNumber)
    }

    const handleChange = (event) => {
        const target =  event.target
        const { value } = target
        setSearchTerm(value)
    }

    const deleteDiscipline = (id) => {
        setDeleteValue(false)
        setOpen(true)
        setCurrentUserId(id)
    }

    const confirmDelete = (id) => {
        return (
            <Confirm open={open}
                    content='Are you sure want to delete this Discipline?'
                    onCancel={close}
                    className="delete-popup"
                    cancelButton='No, cancel it!'
                    confirmButton="Yes, delete it!"
                    onConfirm={() => renderDeleteDiscipline(id)} />
        )
    }

    const close = () => {
        setOpen(false)
        setDeleteValue(true)
    }

    const renderDeleteDiscipline = (id) => {
        deleteDisciplineData(id)
        setOpen(false)
    }

    const handleOpen = (id) => {
        viewDisciplineData(id)
        setIsOpen(!isOpen)
    }

    const getModal = (id) => {
        return(
            <Modal trigger={
                    <Button icon onClick={() => handleOpen(id)} className="view-btn">
                        <Icon name="eye" />
                    </Button>}
                   size='large'
                   closeIcon>
                <Modal.Header> 
                    <span> Discipline Detail </span> 
                </Modal.Header>
                <Modal.Content className="modal-container">
                    <table>
                        <tbody>
                            <tr>
                                <td> Discipline Name: </td>
                                <td> 
                                    {singleDisciplineList.name} 
                                </td>
                            </tr>
                            <tr>
                                <td> Display Name: </td>
                                <td> 
                                    {singleDisciplineList.display_name} 
                                </td>
                            </tr>
                            <tr>
                                <td> Course Title: </td>
                                <td> 
                                    {singleDisciplineList.discipline_details !== undefined ? singleDisciplineList.discipline_details.title : null} 
                                </td>
                            </tr>
                            <tr>
                                <td> Course Tags: </td>
                                <td>
                                    {singleDisciplineList.discipline_details !== undefined ? singleDisciplineList.discipline_details.tags.map(value => value).join(',') : null} 
                                </td>
                            </tr>
                            <tr>
                                <td> Course Summary: </td>
                                <td> 
                                    {singleDisciplineList.discipline_details !== undefined ? singleDisciplineList.discipline_details.summary : null} 
                                </td>
                            </tr>
                            <tr>
                                <td> Growth Title: </td>
                                <td> 
                                    {singleDisciplineList.growth_prospects !== undefined ? singleDisciplineList.growth_prospects.title : null} 
                                </td>
                            </tr>
                            <tr>
                                <td> Job Title: </td>
                                <td> 
                                    {singleDisciplineList.jobs !== undefined ? singleDisciplineList.jobs.title : null} 
                                </td>
                            </tr>
                            <tr>
                                <td> Jobs Name: </td>
                                <td> 
                                    {singleDisciplineList.jobs !== undefined ? singleDisciplineList.jobs.job_name.map(value => value).join(',') : null} 
                                </td>
                            </tr>
                            <tr>
                                <td> Market Opportunity Title: </td>
                                <td> 
                                    {singleDisciplineList.market_opportunity !== undefined ? singleDisciplineList.market_opportunity.title : null}  
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Modal.Content>
            </Modal>
        )
    }

    const getTableBody = () => {
        let serialNo = ((activePage - 1) * pageSize) + 1
        return(
            <Table.Body>
                {disciplineList.map((data, index) => {
                    return(
                        <Table.Row key={data.id} className="form-data">
                            <Table.Cell> {serialNo + index} </Table.Cell>
                            <Table.Cell> {data.name} </Table.Cell>
                            <Table.Cell> {data.display_name} </Table.Cell>
                            <Table.Cell>
                                {getModal(data.id)}
                                <Link to={{ pathname: `/editdiscipline/${data.id}`}}>
                                    <Button icon className="edit-btn">
                                        <Icon name='edit' />
                                    </Button>
                                </Link>
                                <Button icon onClick={() => deleteDiscipline(data.id)} className="delete-btn">
                                    <Icon name='trash' />
                                </Button>
                            </Table.Cell>
                        </Table.Row>
                    )
                })}
            </Table.Body>
        )
    }

    const getTable = () => {
        return(
            <Table basic='very'>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell> S.No </Table.HeaderCell>
                        <Table.HeaderCell> Discipline Name </Table.HeaderCell>
                        <Table.HeaderCell> Display Name </Table.HeaderCell>
                        <Table.HeaderCell> Actions </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                {getTableBody()}
                {deleteValue === false ? confirmDelete(currentUserId) : null}
            </Table>
        )
    }

    return(
        <div className="wrapper">
            <div className="container">
                <Header />
                <Link className="link-container exam-content" to="/dashboard">
                    <Icon name="arrow left" />
                    Back to Dashboard
                </Link>
                <div>
                    <Input type="text"
                           placeholder="Enter text"
                           className="search-box"
                           onChange={handleChange}
                           action={{
                            color: "blue",
                            icon: "search"
                          }}
                           value={searchTerm} />
                     <Link to="/adddiscipline">
                        <Button primary floated='right' className="add-btn">
                            <Icon name="plus" />
                            Add Discipline
                        </Button>
                    </Link>
                </div>
                {loading ? <ReactLoading className="loader-container" type="spin" color="#007bff" height={30} width={30} /> : null}
                {error !== "" ? <h3 className="errorMsg"> {error} </h3> : null}
                {disciplineList !== undefined ? disciplineList.length !== 0 ? getTable() : <h3> No Data </h3> :null}
                <div>
                    {error === "" && count.length > pageSize ?
                    <Pagination activePage={activePage}
                                itemsCountPerPage={itemsCountPerPage}
                                totalItemsCount={count.length}
                                pageRangeDisplayed={pageRangeDisplayed}
                                onChange={handlePageChange} />
                    : error}
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    disciplineList: state.disciplineReducer.disciplineList,
    loading: state.disciplineReducer.loading,
    error: state.disciplineReducer.error,
    singleDisciplineList: state.disciplineReducer.singleDisciplineList,
    count: state.disciplineReducer.count
})

const mapDispatchToProps = {
    getDisciplineList,
    deleteDisciplineData,
    viewDisciplineData
}

export default connect(mapStateToProps, mapDispatchToProps)(DisciplineContainer)